import { useEffect } from "react";
import type { MetaDataPropertyType } from "types/metaDataPropertyTypes";
import type { PropertyCriteria } from "types/qbank/propertyCriteria";
import { SearchOperator } from "types/qbank/searchOperator";
import HierarchicalTree from "./HierarchicalTree";

export default function Hierarchical(props: {
  propertyType: MetaDataPropertyType;
  setCriteria: (propertyCriteria: PropertyCriteria) => void;
  setValues: (value: string[]) => void;
  values: string[];
  isMulti: boolean;
}) {
  useEffect(() => {
    if (props.values !== undefined) {
      props.setCriteria({
        id: props.propertyType.id,
        systemName: props.propertyType.systemname,
        operator: SearchOperator.HIERARCHICAL_ANY,
        value: props.values.map((value) => value.split(">>")),
        label: props.propertyType.name,
      });
    }
    // eslint-disable-next-line
  }, [props.values]);

  const structure =
    JSON.parse(props.propertyType.definition.structure ?? "{}") ?? {};

  return (
    <div className="field" data-testid="hierarchical">
      <label className="label">{props.propertyType.name}</label>

      <div className="control">
        <HierarchicalTree
          structure={structure}
          isMulti={props.isMulti}
          values={props.values}
          inheritedSetter={props.setValues}
        />
      </div>
    </div>
  );
}
